import Vue from "vue";
import Router from "vue-router";
import routes from "@/helpers/router/routes";

Vue.use(Router);

const router = new Router({
  routes: routes
});

export default router;
